<template>
    <b-card class="m-4">
        <b-row class="mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrar" append="registros">
                    <b-form-select v-model="itemsPerPage" id="perPageSelect" size="sm" :options="pageOptions" style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="mb-2" v-if="localeData">
            <b-col sm="12" md="8" lg="6" class="my-1 text-left">
                <b-form-group label="Filtrar por fecha de publicación">
                    <date-range-picker opens="right" :locale-data="localeData" :append-to-body="true" :showWeekNumbers="false"
                                       v-model="dates" :autoApply="true" :linkedCalendars="true" :date-range="dates" :ranges="false"
                                       @update="updateDates">
                        <template v-slot:input style="min-width: 200px;" v-if="!startDate">
                            <span>Fecha inicio - Fecha fin</span>
                        </template>
                    </date-range-picker>
                    <span class="d-none ml-2 d-sm-inline-block"></span>
                    <b-button variant="success" @click="clearDatesInput" style="vertical-align: top;">
                        <font-awesome-icon icon="eraser"></font-awesome-icon> Limpiar
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <b-table :items="loadData" :fields="fields" :filter="filter" :current-page="currentPage" :per-page="itemsPerPage"
                 empty-text="Sin registros" empty-filtered-text="Sin coincidencias" :sort-by.sync="sortBy" class="text-left"
                 striped bordered hover small show-empty responsive ref="publicationsTable">
            <template v-slot:thead-top>
                <b-tr>
                    <b-th v-for="(field, index) in fields" :key="field.key">
                        <b-row>
                            <b-col v-if="filters[index]">
                                <b-input :placeholder="field.label" v-model="filters[index].value" debounce="300"></b-input>
                            </b-col>
                        </b-row>
                    </b-th>
                </b-tr>
            </template>

            <template v-slot:cell(files)="row">
                {{ row.item.files.length }}
            </template>

            <template v-slot:cell(actions)="row">
                <div class="text-center">
                    <b-button-group size="sm">
                        <b-button v-b-tooltip.hover.auto @click="row.toggleDetails" variant="outline-primary"
                                  :title="row.detailsShowing ? 'Ocultar archivos' : 'Ver archivos'">
                            <font-awesome-icon :icon="row.detailsShowing ? 'minus' : 'plus'"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                </div>
            </template>

            <template v-slot:row-details="row">
                <template v-if="row.item.files.length > 0">
                    <b-table :items="row.item.files" :fields="fileFields"
                             striped bordered hover small show-empty responsive style="font-size: .9rem;">
                        <template v-slot:cell(number)="fileRow">{{ fileRow.index + 1 }}</template>

                        <template v-slot:cell(size)="fileRow">{{ formatBytes(fileRow.item.size) }}</template>

                        <template v-slot:cell(actions)="fileRow">
                            <b-button v-b-tooltip.hover.auto title="No disponible" v-if="row.item.locked"
                                      variant="outline-danger" class="px-1 py-0">
                                <font-awesome-icon icon="lock"></font-awesome-icon>
                            </b-button>
                            <b-button-group v-else>
                                <b-button v-b-tooltip.hover.auto v-if="canBePreviewed(fileRow.item)" @click="showPreview(fileRow.item)"
                                          variant="outline-primary" title="Vista previa" class="px-1 py-0">
                                    <font-awesome-icon icon="eye"></font-awesome-icon>
                                </b-button>
                                <b-button v-b-tooltip.hover.auto @click="download(fileRow.item)"
                                          variant="outline-primary" title="Descargar" class="px-1 py-0">
                                    <font-awesome-icon icon="download"></font-awesome-icon>
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-table>
                </template>
                <div class="text-center" v-else> Sin archivos</div>
            </template>
            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Mostrando {{ start }} a {{ end }} de {{ totalRows }} registro<template v-if="totalRows !== 1">s</template>
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>

        <b-modal :id="`file-preview-modal`" size="xl" :title="file.name" ok-title="Cerrar" ok-only>
            <iframe class="object" :src="file.previewData" style="width: 100%; height: 650px;"></iframe>`
        </b-modal>
    </b-card>
</template>

<script>
import { publicationItemsListUrl, fileUrl } from '@routes';
import * as constants from '@constants';
import DateRangePicker from '../../plugins/vue2-daterange-picker';
import { saveAs } from 'file-saver';

import '../../plugins/vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    props: {
        settings: Object,
        dateRangeFormat: String
    },
    data() {
        return {
            fields: [
                { key: 'publicationDate', label: 'Fecha de publicación', sortable: true },
                { key: 'files', label: 'Archivos', class: 'text-center', sortable: false },
                { key: 'actions', label: 'Acciones', sortable: false }
            ],
            filters: [
                { column: 'pi.publication_date', type: 'DATETIME', value: '', format: '' }
            ],
            fileFields: [
                { key: 'number', label: 'Número', class: 'text-right' },
                { key: 'name', label: 'Nombre' },
                { key: 'size', label: 'Tamaño', class: 'text-right' },
                { key: 'actions', label: 'Acciones', class: 'text-center' }
            ],
            filter: '',
            isLoading: false,
            pageOptions: [25, 50, 75, 100],
            totalRows: 0,
            currentPage: 1,
            itemsPerPage: 25,
            sortBy: 'pi.publication_date',
            sortDesc: false,
            localeData: null,
            dates: {
                startDate: null,
                endDate: null
            },
            file: {
                mimetype: '',
                previewData: ''
            },
            fileDownload: false
        }
    },
    components: {
        DateRangePicker
    },
    created() {
        this.$parent.loadData().then(() => {
            for (let i = this.settings.customFields.length - 1; i >= 0; i--) {
                let field = this.settings.customFields[i];

                if (field.enabled) {
                    this.fields.splice(1, 0, {
                        key: `field${i + 1}`,
                        label: field.name,
                        sortable: true
                    });

                    this.filters.splice(1, 0, {
                        column: `pi.field${i + 1}`,
                        type: field.type === 'TEXT' ? 'STRING' : 'DATE',
                        value: '',
                        format: ''
                    });
                }
            }

            this.localeData = {
                direction: 'ltr',
                format: this.dateRangeFormat,
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                weekLabel: 'S',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['D', 'L', 'M', 'Mi', 'J', 'V', 'S'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 0
            };

            if (this.$route.params.encryptedName !== undefined) {
                this.fileDownload =  true;
            }
        });
    },
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    filters: this.filters.filter(filter => filter.value.trim() !== ''),
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;
                data.dates = {
                    startDate: this.startDate,
                    endDate: this.endDate
                };

                return this.axios.post(publicationItemsListUrl(), data).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.totalRows = response.data.totalRows;

                        if (this.fileDownload) {
                            let resultado = response.data.publicationItems.find(item =>
                                item.files.some(file => file.encryptedName == this.$route.params.encryptedName)
                            );

                            if (resultado !== undefined) {
                                let file = resultado.files.find(file => file.encryptedName == this.$route.params.encryptedName);

                                this.download(file);
                            }

                            this.fileDownload = false;
                            this.$router.replace({ name: 'PortalLogin', params: { memberName: this.$route.params.memberName }});
                        }

                        return response.data.publicationItems;
                    } else {
                        return [];
                    }
                }).catch(error => {
                    console.error(error);

                    return [];
                });
            }
        },
        clearDatesInput() {
            this.dates.startDate = null;
            this.dates.endDate = null;

            this.$refs.publicationsTable.refresh();
        },
        updateDates() {
            this.$refs.publicationsTable.refresh();
        },
        formatBytes(size) {
            const ratio = 1024, digits = 2;
            let units = ['B', 'KB', 'MB', 'GB'];
            let unit = 0;

            size = parseInt(size);

            while (size > 1024) {
                size /= ratio;
                unit++;
            }

            return `${size.toFixed(digits)} ${units[unit]}`;
        },
        canBePreviewed(file) {
            let validPreviewMimeTypes = ['application/pdf', 'image/png', 'image/jpeg'];

            return validPreviewMimeTypes.includes(file.mimeType);
        },
        showPreview(file) {
            this.axios.get(fileUrl(), {
                params: {
                    fileId: file.id,
                    isPreview: true
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let blob = this.base64ToBlob(response.data.file, response.data.mimeType);

                    this.file.previewData = URL.createObjectURL(blob);
                    this.file.mimetype = response.data.mimeType;

                    this.$bvModal.show('file-preview-modal');
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            }).catch(error => {
                if (error.response.status === 403) {
                    this.$root.$bvToast.toast(constants.FORBIDDEN_ERROR_MESSAGE, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            });
        },
        download(file) {
            this.axios.get(fileUrl(), {
                params: {
                    fileId: file.id,
                    isPreview: false
                },
                responseType: 'blob'
            }).then(response => {
                saveAs(response.data, file.name);
            }).catch(error => {
                if (error.response.status === 403) {
                    this.$root.$bvToast.toast(constants.FORBIDDEN_ERROR_MESSAGE, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            });
        },
        base64ToBlob(base64, mimeType) {
            const binStr = atob(base64);
            const length = binStr.length;
            const arr = new Uint8Array(length);

            for (let i = 0; i < length; i++) {
                arr[i] = binStr.charCodeAt(i);
            }

            return new Blob([arr], { type: mimeType });
        }
    },
    computed: {
        startDate() {
            let date = '';

            if (this.dates.startDate) {
                date = `${this.dates.startDate.getFullYear()}-${(this.dates.startDate.getMonth() +1).toString().padStart(2, '0')}` +
                    `-${(this.dates.startDate.getDate()).toString().padStart(2, '0')}`
            }

            return date;
        },
        endDate() {
            let date = '';

            if (this.dates.endDate) {
                date = `${this.dates.endDate.getFullYear()}-${(this.dates.endDate.getMonth() + 1).toString().padStart(2, '0')}` +
                    `-${(this.dates.endDate.getDate()).toString().padStart(2, '0')}`
            }

            return date;
        },
        start: function() {
            return this.totalRows === 0 ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        end: function() {
            let offset = (this.currentPage - 1) * this.itemsPerPage;

            return (this.totalRows - offset) < this.itemsPerPage ? this.totalRows : offset + this.itemsPerPage;
        }
    },
    watch: {
        filters: {
            handler() {
                this.$refs.publicationsTable.refresh();
            },
            deep: true
        }
    }
}
</script>

<style>

</style>